export const getSessionDate = () => {
  const env = process.env.VERCEL_ENV;
  if (env === 'production') {
    return null;
  }

  if (typeof window !== 'undefined') {
    const sessionDate = sessionStorage.getItem('mock-date');

    if (sessionDate) {
      return new Date(sessionDate);
    }
  }

  return null;
};
